import { createCustomAction } from 'typesafe-actions';

import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { ResourceType } from '../common/typings';

export const openModal = createCustomAction(
    '@canvasUploadByLinkModal/OPEN',
    type => (fileEditorId: string, urlType: ResourceType) => ({
        type,
        fileEditorId,
        urlType
    })
);

export const closeModal = createCustomAction('@canvasUploadByLinkModal/CLOSE');

export const uploadByLink = createCustomAction(
    '@canvasUploadByLinkModal/UPLOAD_BY_LINK',
    type => (editorId: string, value: string, urlType: ResourceType) => ({
        type,
        editorId,
        value,
        urlType
    })
);

export const changeValue = createCustomAction('@canvasUploadByLinkModal/CHANGE_VALUE', type => (value: string) => ({
    type,
    value
}));

export const showLinkErrors = createCustomAction(
    '@canvasUploadByLinkModal/SHOW_ERRORS',
    type => (errors: ErrorItem[]) => ({
        type,
        errors
    })
);

export type CloseModal = ReturnType<typeof closeModal>;
export type OpenModal = ReturnType<typeof openModal>;
export type UploadByLinkAction = ReturnType<typeof uploadByLink>;

export type UploadByLinkModalAction =
    | CloseModal
    | OpenModal
    | UploadByLinkAction
    | ReturnType<typeof showLinkErrors>
    | ReturnType<typeof changeValue>;
